import { Definition, GaugeMapType, getGaugeMap, MaterialType } from '@steelbuy/ts-shared';
import { DashboardFormData } from './DashboardFormContext';

export const materialsSelection = [
    {
        image: 'HotRolled.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.HOT_ROLLED,
    },
    {
        image: 'HRPO.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.HOT_ROLLED_PICKLED_OILED,
        shortName: 'application.dashboardListings.hrpoShort',
    },
    {
        image: 'ColdRolled.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.COLD_ROLLED,
    },
    {
        image: 'Galvanized.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.GALVANIZED,
    },
    {
        image: 'Galvanneal.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.GALVANNEAL,
    },
    {
        image: 'Galvalume.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.GALVALUME,
    },
    {
        image: 'Aluminized.png',
        materialType: MaterialType.CARBON_STEEL,
        definition: Definition.ALUMINIZED,
    },
    {
        image: 'StainlessSteel.png',
        materialType: MaterialType.STAINLESS_STEEL,
    },
    {
        image: 'Aluminium.png',
        materialType: MaterialType.ALUMINIUM,
    },
];

const isNumberArray = (arr: number[] | GaugeMapType[]): arr is number[] => arr.length > 0 && typeof arr[0] === 'number';

const buildThicknessRanges = (gaugeValues: number[] | GaugeMapType[], gaugeMap: Readonly<GaugeMapType[]>) => {
    const ranges = isNumberArray(gaugeValues)
        ? (gaugeValues ?? [])
              .map((g) => {
                  const match = gaugeMap.find((m) => m.min === g);

                  if (!match) return null;

                  return {
                      minThickness: match.min,
                      maxThickness: match.max,
                  };
              })
              .filter(Boolean)
        : gaugeValues.map((g) => ({ minThickness: g.min, maxThickness: g.max }));

    return {
        thicknessRanges: ranges,
    };
};

export const buildRequestBody = (formData: Partial<DashboardFormData>) => {
    const { sort, location, gauge, ...rest } = formData;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filters: Record<string, any> = { ...rest };

    if (location !== undefined) {
        filters.state = location;
    }

    if (Array.isArray(gauge) && gauge.length > 0) {
        const gaugeMap = getGaugeMap({
            materialType: rest.materialType,
            definition: rest.definition,
            product: rest.product?.[0],
        });
        filters.dimensionRanges = buildThicknessRanges(gauge, gaugeMap);
    }

    // remove undefined properties
    const cleanedFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== undefined));

    return {
        ...cleanedFilters,
        sort,
    };
};
